/**
 * The generated client keys every query as `[{ _id, baseUrl, path, query }]`,
 * so an invalidation filter written as `["getAdminUsers"]` or a predicate
 * comparing `queryKey[0]` to a string silently matches nothing and leaves the
 * list on screen stale. Read the operation id through this helper instead.
 */
export function heyApiQueryId(
  queryKey: readonly unknown[],
): string | undefined {
  const first = queryKey[0] as { _id?: string } | undefined;
  return first?._id;
}

/** Predicate for `invalidateQueries`: matches any of the given operation ids. */
export function isHeyApiQuery(
  queryKey: readonly unknown[],
  ...operationIds: string[]
): boolean {
  const id = heyApiQueryId(queryKey);
  return id !== undefined && operationIds.includes(id);
}
